import { Locale } from 'chaika-enums';
export const profilePage = {
    aboutYourSelf: {
        [Locale.Ru]: 'О себе',
        [Locale.Am]: 'Իմ մասին',
        [Locale.En]: 'About yourself',
        [Locale.Pt]: 'Sobre você',
        [Locale.Ge]: 'საკუთარი თავის შესახებ',
    },
    templateSettings: {
        [Locale.Ru]: 'Настройки шаблонов',
        [Locale.Am]: 'Ձևանմուշների կարգավորումներ',
        [Locale.En]: 'Template settings',
        [Locale.Pt]: 'Configurações do modelo',
        [Locale.Ge]: 'Template settings',
    },
    scheduleSettings: {
        [Locale.Ru]: 'Настройки расписания',
        [Locale.Am]: 'Ժամանակացույցի կարգավորումներ',
        [Locale.En]: 'Schedule settings',
        [Locale.Pt]: 'Configurações de agendamento',
        [Locale.Ge]: 'Schedule settings',
    },
    mySchedule: {
        [Locale.Ru]: 'Мое расписание',
        [Locale.Am]: 'Իմ ժամանակացույցը',
        [Locale.En]: 'My schedule',
        [Locale.Pt]: 'Minha agenda',
        [Locale.Ge]: 'My schedule',
    },
    toTheUser: {
        [Locale.Ru]: 'К пользователю',
        [Locale.Am]: 'Դեպի օգտատեր',
        [Locale.En]: 'To the user',
        [Locale.Pt]: 'Para o usuário',
        [Locale.Ge]: 'To the user',
    },
    hasActiveSchedule: {
        [Locale.Ru]: 'Есть активные модели расписания',
        [Locale.Am]: 'Կան ժամանակացույցի ակտիվ մոդելներ',
        [Locale.En]: 'There are active scheduling models',
        [Locale.Pt]: 'Existem modelos de agendamento ativo',
        [Locale.Ge]: 'There are active scheduling models',
    },
    role: {
        [Locale.Ru]: 'Роль',
        [Locale.Am]: 'Դեր',
        [Locale.En]: 'Role',
        [Locale.Pt]: 'Função',
        [Locale.Ge]: 'Role',
    },
    userList: {
        [Locale.Ru]: 'Список пользователей',
        [Locale.Am]: 'Օգտատերերի ցանկ',
        [Locale.En]: 'User list',
        [Locale.Pt]: 'Lista de usuários',
        [Locale.Ge]: 'User list',
    },
    errorCreatingUser: {
        [Locale.Ru]: 'Ошибка при создании пользователя',
        [Locale.Am]: 'Օգտատեր ստեղծելիս սխալ',
        [Locale.En]: 'Error creating user',
        [Locale.Pt]: 'Erro ao criar usuário',
        [Locale.Ge]: 'Error creating user',
    },
    errorUpdatingUser: {
        [Locale.Ru]: 'Ошибка при сохранении пользователя',
        [Locale.Am]: 'Օգտատիրոջը պահպանելիս սխալ',
        [Locale.En]: 'Error saving user',
        [Locale.Pt]: 'Erro ao salvar usuário',
        [Locale.Ge]: 'მომხმარებლის შენახვისას შეცდომა',
    },
    userFullNameAlreadyExists: {
        [Locale.Ru]: 'Пользователь с таким ФИО уже существует',
        [Locale.Am]: 'Այս ազգանունով, անունով և հայրանունով օգտատեր արդեն գոյություն ունի',
        [Locale.En]: 'A user with this full name already exists',
        [Locale.Pt]: 'Já existe um usuário com este nome completo',
        [Locale.Ge]: 'ამ სრული სახელით მომხმარებელი უკვე არსებობს',
    },
    cannotChangeStatus: {
        [Locale.Ru]: 'Нельзя поменять статус',
        [Locale.Am]: 'Հնարավոր չէ փոխել կարգավիճակը',
        [Locale.En]: 'Cannot change status',
        [Locale.Pt]: 'Não é possível alterar o status',
        [Locale.Ge]: 'Cannot change status',
    },
    createWorkingTime: {
        [Locale.Ru]: 'Создать рабочее время',
        [Locale.Am]: 'Ստեղծել աշխատանքային ժամ',
        [Locale.En]: 'Create working time',
        [Locale.Pt]: 'Criar horário de trabalho',
        [Locale.Ge]: 'Create working time',
    },
    viewWorkingTimeText: {
        [Locale.Ru]: 'Посмотреть рабочее время модели расписания',
        [Locale.Am]: 'Դիտել ժամանակացույցի մոդելի աշխատանքային ժամերը',
        [Locale.En]: 'View working hours of the schedule model',
        [Locale.Pt]: 'Visualizar horário de funcionamento do modelo de cronograma',
        [Locale.Ge]: 'View working hours of the schedule model',
    },
    doctorScheduleSettings: {
        [Locale.Ru]: 'Настройка расписания врача',
        [Locale.Am]: 'Բժշկի ժամանակացույցի կարգավորում',
        [Locale.En]: `Setting up a doctor's schedule`,
        [Locale.Pt]: 'Configuração da agenda do médico',
        [Locale.Ge]: `Setting up a doctor's schedule`,
    },
    // NAME: {
    //     [Locale.Ru]: ``,
    //     [Locale.Am]: ``,
    //     [Locale.En]: ``,
    // [Locale.Pt]: '',
    //     [Locale.Ge]: ``,
    // },
};
